import { render } from "./Moat.vue?vue&type=template&id=0fb78249"
import script from "./Moat.vue?vue&type=script&lang=js"
export * from "./Moat.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/buildings/Moat.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0fb78249"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0fb78249', __exports__)) {
    api.reload('0fb78249', __exports__)
  }
  
  module.hot.accept("./Moat.vue?vue&type=template&id=0fb78249", () => {
    api.rerender('0fb78249', render)
  })

}


export default __exports__